module.exports = __webpack_public_path__ + "img/FullbackLight1.bc0d5622.jpg";